function addMotoTyreToCart(event, tyreId, quantity) {
    event.preventDefault();
    var tyres = new Array();
    tyres.push({ "code": tyreId, "quantity": quantity });
    var productCartData = {"items": tyres, "price": '', "discountedPrice": '' };
    postMoto(productCartData,'/tyres/addToCart');
};

function addMotoTyresToCart(event, price, discountedPrice, tyreIds) {
    event.preventDefault();
    var tyres = new Array();

    for (var i in tyreIds) {
        var tyreCode = tyreIds[i];
        var tyre = tyres.filter(function (el) {
            return el.code === tyreCode;
        });
        (tyre && tyre.length > 0) ? tyre[0].quantity++ : tyres.push({"code": tyreCode, "quantity": 1});
    }

    var productCartData = {"items": tyres, "price": price, "discountedPrice": discountedPrice };
    postMoto(productCartData,'/tyres/addToCart');
};

var postMoto = function (data,url){
    var token = $("meta[name='_csrf']").attr("content");
    var header = "X-CSRF-TOKEN";
    $.ajax({
        url: url ,
        type: 'POST',
        contentType: "application/json",
        dataType: 'json',
        data: JSON.stringify(data.items),
        beforeSend: function(xhr) {
            xhr.setRequestHeader(header, token);
        },
        success: function (response) {
            $( document ).trigger( "changeCartEvent", data);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            if (xhr.status === 400 && xhr.responseJSON && xhr.responseJSON.error) {
                 $('#limitCartEntriesMessage').text(xhr.responseJSON.error);
                 $('#limitCartEntriesModal').modal('show');
            }
        }
     });
}

var MOTO_SEARCH = (function () {
    function handleFilterButtonClick(target) {
        var filterButtonId = "motoFilterButton";
        var searchFilterSelector = "#motoSearchFilters #motoSearchResultFilters";
        var $searchFilter = $(searchFilterSelector);
        if ($searchFilter.length > 0) {
            if ((target.id === filterButtonId || (target.parentNode && target.parentNode.id === filterButtonId)) && $searchFilter.css('display') === 'none') {
                $searchFilter.show();
            } else {
                var targetParent = target.closest(searchFilterSelector);
                if (!targetParent || targetParent.length === 0) {
                    $searchFilter.hide()
                }
            }
        }
    }

    function displayPaginatedElementAt(element) {
        var elementsClass = $(element).data("elements");
        var buttonsClass = $(element).data("buttons");
        var position = $(element).data("index");
        var elements = $("." + elementsClass);
        var buttons = $("." + buttonsClass);

        $(elements).hide();
        $(buttons).removeClass("selected");
        $("#" + elementsClass + position).show();
        $("." + buttonsClass + position).addClass("selected");
    }

    return {
        handleFilterButtonClick: handleFilterButtonClick,
        displayPaginatedElementAt: displayPaginatedElementAt
    }
}) (jQuery);

$(document).ready(function() {
    $('html').on('click', function(e) {
        MOTO_SEARCH.handleFilterButtonClick(e.target);
    });
    $('.matching-pagination-element').on('click', function(e) {
        MOTO_SEARCH.displayPaginatedElementAt(e.target);
    });
});

